import React from 'react';
import { ShieldCheck, Medal, Star, Badge as BadgeIcon } from 'lucide-react';

export const getBadgeIcon = (category) => {
  switch (category?.toLowerCase()) {
    case 'verified':
      return ShieldCheck;
    case 'contribution':
      return Medal;
    case 'quality':
      return Star;
    default:
      return BadgeIcon;
  }
};

export const formatBadgeDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};
